import { normalizePathname } from '@zapier/url-utils';
export const isLinkSelected = (linkHref, currentPageHref, shouldHighlightOnlyOnExactHref = false) => {
    let parsedCurrentPageHref;
    let parsedLinkHref;
    try {
        parsedLinkHref = new URL(linkHref);
    }
    catch (_a) {
    }
    try {
        parsedCurrentPageHref = new URL(currentPageHref);
    }
    catch (_b) {
    }
    if (parsedCurrentPageHref && parsedLinkHref) {
        if (shouldHighlightOnlyOnExactHref) {
            return currentPageHref === linkHref;
        }
        return currentPageHref.startsWith(linkHref);
    }
    const currentPath = (parsedCurrentPageHref === null || parsedCurrentPageHref === void 0 ? void 0 : parsedCurrentPageHref.pathname) || currentPageHref;
    const linkPath = (parsedLinkHref === null || parsedLinkHref === void 0 ? void 0 : parsedLinkHref.pathname) || linkHref;
    const normalizedCurrentPath = normalizePathname(currentPath);
    const normalizedLinkPath = normalizePathname(linkPath);
    if (shouldHighlightOnlyOnExactHref) {
        return normalizedCurrentPath === normalizedLinkPath;
    }
    return normalizedCurrentPath.startsWith(normalizedLinkPath);
};
//# sourceMappingURL=utils.js.map
// @zapier/universal-layout@11.4.3 (295ef9cfc)
